import React from 'react'

const PaginatorPagesList = ({currentPage, pages, handlePageClick, paginatorSize}) => {
  const numberList = Array.from(
    new Array(pages > paginatorSize ? paginatorSize : pages)
  ).map((_, i) => i + 1);

  if (pages > paginatorSize) {
    const paginatorCenter = Math.ceil(paginatorSize / 2);

    if (currentPage > paginatorCenter) {
      numberList[0] = 1;
      numberList[1] = '...';

      for (let i = 2; i < paginatorSize; i++) {
        numberList[i] = currentPage - paginatorCenter + i + 1;
      }
    }

    if (currentPage < pages - paginatorCenter + 1) {
      numberList[paginatorSize - 1] = pages;
      numberList[paginatorSize - 2] = '...';
    } else {
      for (let i = 2; i < paginatorSize; i++) {
        numberList[i] = pages - paginatorSize + i + 1;
      }
    }
  }

  const pagesList = numberList.map((number, i) => {
    const className = currentPage === number ? "active" : null;

    return (
      <li className={className} key={i}>
        <a href="/" onClick={handlePageClick}>{number}</a>
      </li>
    )
  });

  return (
    <ul>
      {pagesList}
    </ul>
  )
};

export default PaginatorPagesList
